export const VERSION = '1.6.0';
export const LIB = '@dark-engine/data';
export const ROOT_ID = '__ROOT__';
